import React from 'react';
import { Plane, MapPin, Shield, Star } from 'lucide-react';
import { motion } from 'framer-motion';

const Transfers: React.FC = () => {
  return (
    <div className="pt-40 pb-20 bg-black min-h-screen px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        
        {/* H1 Optimisé pour "Service Limousine" + "Genève" + "Lausanne" */}
        <motion.h1 
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="font-serif text-4xl md:text-6xl text-white mb-20 leading-tight"
        >
          Service Limousine <br className="hidden md:block" /> 
          <span className="text-slate-300">Genève (GVA)</span> ⇄ <span className="text-slate-300">Lausanne</span>
        </motion.h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-16 mb-32">
           <div className="lg:col-span-2 space-y-12">
              
              {/* Introduction riche en mots-clés géographiques */}
              <motion.p 
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-xl md:text-2xl text-slate-300 font-light leading-relaxed"
              >
                 Transformez votre arrivée en Suisse. LimoHass assure votre <strong className="text-white font-medium">transfert VIP entre l'aéroport de Genève et Lausanne</strong> (ou toute destination en Suisse Romande). 
                 <br /><br />
                 Que vous rejoigniez le Beau-Rivage Palace, l'EPFL ou votre résidence privée, nos chauffeurs garantissent une prise en charge immédiate dès la sortie de l'avion.
              </motion.p>
              
              {/* Features avec titres optimisés */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-white/10 pt-8">
                 {[
                    { 
                      icon: Plane, 
                      title: "Suivi Vol GVA", // Mot clé GVA
                      desc: "Nous monitorons votre vol en temps réel. En cas d'avance ou de retard à Genève, votre chauffeur s'adapte instantanément." 
                    },
                    { 
                      icon: Star, 
                      title: "Accueil Pancarte", // Mot clé visuel
                      desc: "Votre chauffeur vous attend directement après la douane avec une tablette nominative. Assistance bagages incluse." 
                    },
                    { 
                      icon: Shield, 
                      title: "Sécurité Diplomatique", // Mot clé confiance
                      desc: "Conduite experte et discrétion absolue pour nos clients, VIP" 
                    }
                 ].map((item, i) => (
                    <motion.div 
                       key={i}
                       initial={{ opacity: 0, y: 20 }}
                       whileInView={{ opacity: 1, y: 0 }}
                       viewport={{ once: true }}
                       transition={{ delay: 0.4 + (i * 0.15) }}
                    >
                       <item.icon className="text-white mb-4" size={32} />
                       <h4 className="text-white font-serif text-lg mb-2">{item.title}</h4>
                       <p className="text-sm text-slate-500 leading-relaxed">{item.desc}</p>
                    </motion.div>
                 ))}
              </div>
           </div>
        </div>

        {/* Image avec Alt Text SEO et Overlay Branding */}
        <motion.div 
           initial={{ opacity: 0, scale: 0.95 }}
           whileInView={{ opacity: 1, scale: 1 }}
           viewport={{ once: true }}
           transition={{ duration: 1 }}
           className="h-[300px] md:h-[500px] w-full relative grayscale overflow-hidden rounded-sm"
        >
           {/* Alt text très précis pour Google Images */}
           <img 
             src="/ville-geneva.webp" 
             alt="Chauffeur privé Mercedes transfert aéroport Genève vers Lausanne et Montreux" 
             className="w-full h-full object-cover" 
           />
           <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center space-y-4">
              <span className="text-white font-serif text-2xl md:text-5xl text-center px-4 italic">
                L'excellence du trajet.
              </span>
              <div className="flex items-center gap-2 text-white/80 font-light text-center px-6 tracking-widest uppercase text-xs md:text-sm">
                <MapPin size={14} />
                <span>Genève • Lausanne • Montreux • Gstaad • Zürich</span>
              </div>
           </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Transfers;